export default "__VITE_ASSET__DfwidmmP__"